import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/index";
import "primereact/resources/themes/lara-light-blue/theme.css";
import 'primeflex/primeflex.css';


import App from "./App";

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.getRegistrations().then(registrations => {
//     for (let registration of registrations) {
//       registration.unregister();
//     }
//   });
// }

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);


